import React, { FC } from 'react'
import {
  HotWeatherWarningContainer,
  HotWeatherWarningHeaderText,
  HotWeatherWarningParagraph,
  HotWeatherWarningSection,
  HotWeatherWarningH2Text,
} from './HotWeatherWarning.styles'

export const HotWeatherWarning: FC = () => {
  return (
    <HotWeatherWarningContainer>
      <HotWeatherWarningSection>
        <HotWeatherWarningH2Text role="text">Hot weather travel advice</HotWeatherWarningH2Text>
        <HotWeatherWarningParagraph>
          Extreme heat is expected across parts of the UK on Thursday 25 and Friday 26 June.
          <br />
          <br />
          The weather can have a big impact on the railway. Trains may need to run at reduced speeds to keep passengers safe, which means
          delays, cancellations and last-minute changes are more likely.
          <br />
          <br />
          If your journey isn't essential, please consider travelling on another day.
        </HotWeatherWarningParagraph>
        <HotWeatherWarningHeaderText role="text">Before you travel</HotWeatherWarningHeaderText>
        <HotWeatherWarningParagraph>
          <ul>
            <li>Check your journey before leaving for the station.</li>
            <li>Allow extra time for your journey.</li>
            <li>Keep an eye on live travel updates while you're travelling.</li>
            <li>Be prepared for delays or changes to your train.</li>
          </ul>
          For the latest travel advice and disruption information, please visit the {' '}
          <a href="https://www.nationalrail.co.uk/status-and-disruptions/" target="_blank" rel="noreferrer">
            National Rail website
          </a>
          .
        </HotWeatherWarningParagraph>
        <HotWeatherWarningHeaderText role="text">Staying safe in the heat</HotWeatherWarningHeaderText>
        <HotWeatherWarningParagraph>
          If you do need to travel:
          <ul>
            <li>Take plenty of water with you and stay hydrated.</li>
            <li>Wear light clothing where possible.</li>
            <li>Allow extra time when walking through stations or between connections.</li>
            <li>If you start to feel unwell, seek help from station staff.</li>
          </ul>
        </HotWeatherWarningParagraph>
        <HotWeatherWarningHeaderText role="text">Travelling later</HotWeatherWarningHeaderText>
        <HotWeatherWarningParagraph>
          If you've got a ticket booked for travel on Thursday 25 or Friday 26 June, you can use it instead to travel any day up to and
          including Tuesday 30 June without changing your booking.
          <br />
          <br />
          You'll still need to follow any restrictions that apply to your ticket. For example, if you've booked an Off-Peak ticket, you'll
          need to travel on an eligible Off-Peak service.
          <br />
          <br />
          If you're unsure whether your ticket is valid for your planned journey, please check before you travel.
        </HotWeatherWarningParagraph>
        <HotWeatherWarningHeaderText role="text">Ticket refunds</HotWeatherWarningHeaderText>
        <HotWeatherWarningParagraph>
          If you booked a ticket for travel on Tuesday 23 through Friday 26 June and no longer wish/wished to travel, you can request a
          full refund with no admin fee.
          <br />
          <br />
          Please visit our{' '}
          <a href="https://virgintrains-refunds.fastrailticketing.com/" target="_blank" rel="noreferrer">
            refund form
          </a>{' '}
          to request your refund. When choosing reason for refund, select “booking error / changed mind”.
        </HotWeatherWarningParagraph>
      </HotWeatherWarningSection>
    </HotWeatherWarningContainer>
  )
}
